import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import "./Faq.css";
import { Link } from "react-router-dom";
import { fetchAPI } from "../utils/api";

const defaultFaqs = [
  {
    hf_id: 1,
    hf_title: "What services does CaresAtHome provide?",
    ht_description: "We provide nursing care, physiotherapy, bedside attendants, ICU setup, doctor consultations, diagnostics, emergency services, and medical equipment support."
  },
  {
    hf_id: 2,
    hf_title: "How do I book a nurse or bedside attendant at home?",
    ht_description: "You can book directly through our website by selecting your required service and care plan, or by calling our customer support team."
  },
  {
    hf_id: 3,
    hf_title: "Are the caregivers and nurses background-verified?",
    ht_description: "Yes, all our healthcare professionals and caregivers undergo strict background checks, qualification verification, and clinical training before assignment."
  },
  {
    hf_id: 4,
    hf_title: "What shift durations are available for home nursing?",
    ht_description: "We offer flexible shift options including 6 Hours, 8 Hours, 12 Hours, and 24 Hours (Live-in) care depending on patient requirements."
  },
  {
    hf_id: 5,
    hf_title: "Can I customize the care plan duration?",
    ht_description: "Yes, we offer both Short Term care services and Long Term packages (7 Days, 15 Days, 30 Days) tailored to patient needs."
  }
];

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      setLoading(true);
      const res = await fetchAPI('faq');
      if (res && res.result && Array.isArray(res.result) && res.result.length > 0) {
        setFaqs(res.result);
      } else {
        setFaqs(defaultFaqs);
      }
    } catch (err) {
      console.error("Error fetching FAQs:", err);
      setFaqs(defaultFaqs);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Header/>
      
    <div className="second_breadcum">
        <div className="container-fluid">
            <div className="inner_second_breadcum">
                <h1>Frequently Asked   <span> Questions</span></h1>
                <div className="Sec-breadcrumb">
                    <Link to="/">Home</Link>
                    <span>&gt;</span>
                    <span>FAQ</span>
                </div>
            </div>
        </div>
    </div>

    <div className="faq_main">
        <div className="container">
            <div className="faq_innner">

                <div className="accordion" id="accordionExample">
                    {faqs && faqs.length > 0 ? (
                      faqs.map((faq, index) => {
                        const faqTitle = faq.hf_title || faq.title || faq.question || faq.tf_title || "FAQ";
                        const faqDesc = faq.ht_description || faq.hf_description || faq.description || faq.answer || faq.tf_description || "";
                        const faqId = faq.hf_id || faq.id || index;
                        return (
                          <div className="accordion-item" key={faqId}>
                              <h2 className="accordion-header">
                              <button 
                                className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`} 
                                type="button" 
                                data-bs-toggle="collapse" 
                                data-bs-target={`#collapseFaq-${faqId}`} 
                                aria-expanded={index === 0 ? "true" : "false"} 
                                aria-controls={`collapseFaq-${faqId}`}
                              >
                                  {faqTitle}
                              </button>
                              </h2>
                              <div 
                                id={`collapseFaq-${faqId}`} 
                                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`} 
                                data-bs-parent="#accordionExample"
                              >
                              <div className="accordion-body">
                                  {faqDesc}
                              </div>
                              </div>
                          </div>
                        );
                      })
                    ) : (
                      !loading && <p className="p-3 text-muted">No FAQs found.</p>
                    )}
                </div>

            </div>
        </div>
    </div>

    <Footer/>
    </>
  );
}
